import React from 'react';

const AdminDashboard: React.FC = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Admin Dashboard</h1>
      <p className="mt-4">Protected admin area. Replace with real UI.</p>
    </div>
  );
};

export default AdminDashboard;
